import React, { useEffect } from 'react'
import { appendParamToURL } from '../../../js/util'
import { fetchInventoryMsg } from 'actions/ApiRequests'

const PDPInventoryMsg = React.memo(props => {
    const {storeID, pid, pid2, qty, qty2, fetchInventoryMsgURL, dispatch, inventoryMsg} = props;

    useEffect(() => {
        if (qty && pid) {
            const data = [{
                name: 'storeid',
                value: storeID
            }, {
                name: 'skus',
                value: pid + (pid2 ? `,${pid2}` : '')
            }, {
                name: 'quantities',
                value: qty + (qty2 ? `,${qty2}` : '')
            }];

            const finalURL = data.reduce((acum, data) => {
                return appendParamToURL(acum, data.name, data.value);
            }, fetchInventoryMsgURL);

            dispatch(fetchInventoryMsg(finalURL));
        }
    }, [storeID, pid, pid2, qty, qty2, fetchInventoryMsgURL, dispatch]);

    if (pid && qty && inventoryMsg) {
        return (
            <p>
                <b>
                    {inventoryMsg.split('\n').join('')}
                </b>
            </p>
        )
    } else {
        return '';
    }
});

export default PDPInventoryMsg;
